import { library } from '@fortawesome/fontawesome-svg-core'
import { faGift } from '@fortawesome/free-solid-svg-icons'
import {
  faBox as farBox,
  faCamera as farCamera,
  faCircle as farCircle,
  faCircleExclamation,
  faCircleInfo as farCircleInfo,
  faHeart as farHeart,
  faMagnifyingGlassPlus as farMagnifyingGlassPlus,
  faTrashCan as farTrashCan,
  faXmark as farXmark
} from '@fortawesome/pro-regular-svg-icons'
import {
  faArrowLeft,
  faArrowRight,
  faArrowsRotate,
  faBook,
  faBookOpen,
  faCamera,
  faCartShopping,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronsUp,
  faChevronUp,
  faCircle,
  faCircleArrowDown,
  faCircleArrowLeft,
  faCircleArrowRight,
  faCircleArrowUp,
  faCircleCheck,
  faCircleInfo,
  faCircleQuestion,
  faCrop,
  faCrown,
  faDownload,
  faHeart,
  faLockKeyhole,
  faMinus,
  faPlus,
  faSearch,
  faShare,
  faSpinner,
  faTag,
  faTimes,
  faTrash,
  faUpload,
  faUserCircle,
  faWandSparkles,
  faXmark
} from '@fortawesome/pro-solid-svg-icons'

export const iconIds = {
  faArrowLeft: ['fas', 'arrow-left'],
  faArrowRight: ['fas', 'arrow-right'],
  faArrowsRotate: ['fas', 'arrows-rotate'],
  faBook: ['fas', 'book'],
  faBookOpen: ['fas', 'book-open'],
  farBox: ['far', 'box'],
  faCamera: ['fas', 'camera'],
  farCamera: ['far', 'camera'],
  faCartShopping: ['fas', 'cart-shopping'],
  faCheck: ['fas', 'check'],
  faChevronDown: ['fas', 'chevron-down'],
  faChevronLeft: ['fas', 'chevron-left'],
  faChevronRight: ['fas', 'chevron-right'],
  faChevronUp: ['fas', 'chevron-up'],
  faChevronsUp: ['fas', 'chevrons-up'],
  faCircle: ['fas', 'circle'],
  faCircleArrowDown: ['fas', 'circle-arrow-down'],
  faCircleArrowLeft: ['fas', 'circle-arrow-left'],
  faCircleArrowRight: ['fas', 'circle-arrow-right'],
  faCircleArrowUp: ['fas', 'circle-arrow-up'],
  faCircleCheck: ['fas', 'circle-check'],
  faCircleInfo: ['fas', 'circle-info'],
  faCircleQuestion: ['fas', 'circle-question'],
  faCrop: ['fas', 'crop'],
  faCrown: ['fas', 'crown'],
  faDownload: ['fas', 'download'],
  faGift: ['fas', 'gift'],
  faHeart: ['fas', 'heart'],
  faLockKeyhole: ['fas', 'lock-keyhole'],
  faMinus: ['fas', 'minus'],
  faPlus: ['fas', 'plus'],
  faSearch: ['fas', 'search'],
  faShare: ['fas', 'share'],
  faSpinner: ['fas', 'spinner'],
  faTag: ['fas', 'tag'],
  faTimes: ['fas', 'times'],
  faTrash: ['fas', 'trash'],
  faUpload: ['fas', 'upload'],
  faUserCircle: ['fas', 'user-circle'],
  faWandSparkles: ['fas', 'wand-sparkles'],
  faXmark: ['fas', 'xmark'],
  farCircle: ['far', 'circle'],
  farCircleExclamation: ['far', 'circle-exclamation'],
  farCircleInfo: ['far', 'circle-info'],
  farHeart: ['far', 'heart'],
  farMagnifyingGlassPlus: ['far', 'magnifying-glass-plus'],
  farTrashCan: ['far', 'trash-can'],
  farXmark: ['far', 'xmark']
}

export function initIconLibrary() {
  library.add(
    faArrowLeft,
    faArrowRight,
    faArrowsRotate,
    faBook,
    faBookOpen,
    faCamera,
    farCamera,
    faCartShopping,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faChevronsUp,
    faCircle,
    faCircleArrowDown,
    faCircleArrowLeft,
    faCircleArrowRight,
    faCircleArrowUp,
    faCircleCheck,
    faCircleExclamation,
    faCircleInfo,
    faCircleQuestion,
    faCrop,
    faCrown,
    faDownload,
    faGift,
    faHeart,
    faLockKeyhole,
    faMinus,
    faPlus,
    faSearch,
    faShare,
    faSpinner,
    faTag,
    faTimes,
    faTrash,
    faUpload,
    faUserCircle,
    faWandSparkles,
    faXmark,
    farBox,
    farCircle,
    farCircleInfo,
    farHeart,
    farMagnifyingGlassPlus,
    farTrashCan,
    farXmark
  )
}
